export default {"src":"/_next/static/media/sparkles.21546147.svg","height":17,"width":17,"blurWidth":0,"blurHeight":0};